<template>
	<div v-loading.fullscreen.lock="visible.loading" element-loading-background="rgba(0, 0, 0, 0.4)">
		<div class="crumbs">
			<el-breadcrumb separator="/">
				<el-breadcrumb-item><i class="icon-lx-calendar"></i> 待办业务</el-breadcrumb-item>
				<el-breadcrumb-item>待办车辆</el-breadcrumb-item>
			</el-breadcrumb>
		</div>

		<div class="container">
			<el-row>
				<el-col :span="5">
					<div class="handle-box">
						<el-input placeholder="单位名称" suffix-icon="el-icon-search" v-model.lazy="data.filterDeptStr"
							@change="filterDept" size="large" clearable>
							<el-checkbox slot="prepend" v-model="data.containSubEmployee"
								@change="changeContainSubEmployee">包含下级</el-checkbox>
						</el-input>
					</div>
					<div style="max-height:600px;overflow:auto;">
						<el-tree ref="depts" :data="data.depts" node-key="id" :check-on-click-node="true"
							highlight-current :expand-on-click-node="false" @node-click="handleDeptNodeClick"
							:filter-node-method="handleTreeFilter">
							<span class="span-ellipsis" slot-scope="{ node, data }">
								<span :title="node.label">{{ node.label }}</span>
							</span>
						</el-tree>
					</div>
				</el-col>
				<el-col :span="1">
					&nbsp;
				</el-col>
				<el-col :span="18">
					<div class="handle-box left">
						<el-input v-model="data.filterstr" placeholder="车牌号" size="large" style="width:350px;">
							<!--<el-button slot="append" type="primary" icon="if-lcon-duqushenfenzheng"></el-button>-->
						</el-input>
						<el-button class="ml10" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
					</div>
					<div class="handle-box right">
						<el-button ref="handle" class="ml10" type="primary" icon="el-icon-edit-outline"
							@click="toHandle" v-if="power.handle" :disabled="data.curVehId == 0">受理
						</el-button>
						<el-popconfirm title="是否删除该待办信息？" v-if="power.remove" @confirm="removeApply">
							<el-button ref="remove" class="ml10" type="danger" 
								icon="el-icon-delete" slot="reference" :disabled="data.curVehId == 0">删除
							</el-button>
						</el-popconfirm>
					</div>

					<el-table ref="table" :data="data.rows" border class="table" row-key="id" highlight-current-row
						@current-change="tableCurrentChange">
						<el-table-column prop="code" label="车辆编号" width="170">
						</el-table-column>
						<el-table-column prop="licensePlate" label="车牌号" width="140">
						</el-table-column>
						<el-table-column prop="applyDate" label="推送日期" width="160">
						</el-table-column>
						<el-table-column prop="deptName" label="单位" show-overflow-tooltip>
						</el-table-column>
						<el-table-column prop="doorPost" label="权限组" width="150">
						</el-table-column>
						<el-table-column prop="validDate" label="有效期" width="450">
						</el-table-column>
					</el-table>
					<div class="pagination">
						<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentPageChange"
							:current-page="data.page" :page-sizes="[10,20,50,100,200,300,400,500]"
							:page-size="data.size" layout="total, sizes, prev, pager, next, jumper" :total="data.total">
						</el-pagination>
					</div>
				</el-col>
			</el-row>
		</div>

		<el-dialog title="车辆待办受理" :visible.sync="visible.handle" v-if="power.handle && visible.handle" width="1024px"
			center :close-on-click-modal="false">
			<div style="height:540px;">
				<el-row>
					<el-steps :active="data.handle.step" finish-status="success">
						<el-step title="信息核验"></el-step>
						<el-step title="司机信息"></el-step>
						<el-step title="鉴权"></el-step>
						<el-step title="办理完成"></el-step>
					</el-steps>
				</el-row>
				<div>&nbsp;</div>
				<el-form @submit.native.prevent label-width="140px">
					<el-row v-if="data.handle.step == 0">
						<el-row>
							<el-col :span="12">
								<el-form-item label="证件编号:">
									<el-input v-model="data.info.code" size="large" readonly></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="12">
							</el-col>
						</el-row>
						<el-row>
							<el-col :span="12">
								<el-form-item label="车牌号:">
									<el-input v-model="data.info.licensePlate" size="large" readonly
										:class="data.info.hasVeh ? 'red' : ''"></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<span style="color:blue;display:inline-block;" v-if="data.info.hasVeh">该车辆信息在系统中已存在
									<el-checkbox class="ml10" v-model="data.info.clearDrivers"
										:disabled="data.info.diffDept">重新添加司机</el-checkbox></span>
							</el-col>
						</el-row>
						<el-row v-if="data.info.hasVeh && data.info.diffDept">
							<el-col :span="12">
								<el-form-item label="原单位:">
									<el-input v-model="data.info.oldDept" size="large" readonly></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="12">
							</el-col>
						</el-row>
						<el-row>
							<el-col :span="12">
								<el-form-item label="单位:">
									<el-input v-model="data.info.realDeptName" size="large" readonly
										:class="data.info.hasVeh && data.info.diffDept ? 'red' : ''"></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<span style="color:red;display:inline-block;"
									v-if="data.info.hasVeh && data.info.diffDept">注：单位已变更，请审核<el-checkbox class="ml10"
										v-model="data.handle.canCheckData1">同意继续办理</el-checkbox></span>
							</el-col>
						</el-row>
						<!--<el-form-item label="司机:">
							<el-input v-model="data.info.dri" size="large"></el-input>
						</el-form-item>-->
						<el-form-item label="照片:">
							<div style="height:200px;width:100%;">
								<el-row>
									<el-col :span="8">
										<img :src="data.image.img"
											style="height:200px;width:100%;object-fit:contain;" />
									</el-col>
									<el-col :span="7">
										<el-button type="primary" @click="loadLocationImage"
											style="width:200px;margin:2px 2px 2px 10px;">本地上传
										</el-button>
										<el-button type="primary" @click="toCropper"
											style="width:200px;margin:2px 2px 2px 10px;">图片裁剪
										</el-button>
									</el-col>
								</el-row>
							</div>
						</el-form-item>
					</el-row>
					<el-row v-if="data.handle.step == 1">
						<el-button icon="if-lcon-yuangongdaoru" @click="toSelectDrivers">添加司机</el-button>
						<el-table ref="drivers" :data="data.info.drivers" border class="table" row-key="id"
							highlight-current-row>
							<el-table-column prop="code" label="工号" width="140">
							</el-table-column>
							<el-table-column prop="name" label="姓名" width="120">
							</el-table-column>
							<el-table-column prop="deptName" label="单位" show-overflow-tooltip>
							</el-table-column>
							<el-table-column prop="validDate" label="有效期" width="150">
							</el-table-column>
							<el-table-column prop="opt" label="操作" width="130">
								<template slot-scope="scope">
									<el-button icon="el-icon-delete" @click="doRemoveDriver(scope.$index)">移除
									</el-button>
								</template>
							</el-table-column>
						</el-table>
					</el-row>
					<el-row v-if="data.handle.step == 2">
						<el-form-item label="单位:">
							<el-input v-model="data.info.realDeptName" size="large"></el-input>
						</el-form-item>
						<el-form-item label="车牌号:">
							<el-input v-model="data.info.licensePlate" size="large"></el-input>
						</el-form-item>
						<el-form-item>
							<el-checkbox v-model="data.info.isNormal" size="large">刷人卡</el-checkbox>
						</el-form-item>
						<el-form-item label="权限:">
							<el-checkbox-group size="mini" v-model="data.handle.power">
								<el-checkbox-button v-for="ag in data.authorizeGroups" :label="ag.id" :key="ag.id">
									{{ag.name}}
								</el-checkbox-button>
							</el-checkbox-group>
						</el-form-item>
					</el-row>
					<el-row v-if="data.handle.step == 4">
						<div style="text-align:center;width:600px;height:300px;margin:auto;">
							<img src="../../assets/img/ok.png" width="120px"
								style="display:block;margin:auto;margin-top:100px;" />
							车辆信息办理完成，请点击右下方按钮回到待办列表。
						</div>
					</el-row>
				</el-form>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button class="right" type="primary" @click="finishCheckData" v-if="data.handle.step == 0"
					:disabled="!data.handle.canCheckData1">下一步</el-button>
				<el-button class="left" type="infor" @click="backToCheckData" v-if="data.handle.step == 1">上一步
				</el-button>
				<el-button class="right" type="primary" @click="finishDrivers" v-if="data.handle.step == 1">下一步
				</el-button>
				<el-button class="left" type="infor" @click="backToDrivers" v-if="data.handle.step == 2">上一步</el-button>
				<el-button class="right" type="primary" @click="saveData" v-if="data.handle.step == 2">保存</el-button>
				<el-button class="right" type="infor" @click="doCloseHandle" v-if="data.handle.step == 3">关闭</el-button>
				<el-button class="right" type="primary" @click="visible.handle = false" v-if="data.handle.step == 4">完成
				</el-button>
			</div>
		</el-dialog>

		<el-dialog title="司机选择" :visible.sync="visible.selectEmp" width="1024px" center :close-on-click-modal="false">
			<el-input v-model="data.filterselempstr" @change="searchSelectEmpoyee" size="large" style="width:500px;"
				placeholder="请刷入单位名称/工号/姓名/身份证">
				<el-button slot="append" type="primary" icon="if-lcon-duqushenfenzheng" @click="readFromIdCardReader">
				</el-button>
			</el-input>
			<el-button class="ml10" type="primary" icon="el-icon-search" row-key="id" @click="searchSelectEmpoyee">搜索
			</el-button>
			<el-table ref="selectEmps" class="table" border :data="data.selectEmployees" height="400"
				@selection-change="selectEmpHandleSelectionChange" @cell-click="selectEmpHandleCellClick">
				<el-table-column type="selection"></el-table-column>
				<el-table-column prop="code" label="工号" width="140"></el-table-column>
				<el-table-column prop="name" label="姓名" width="120"></el-table-column>
				<el-table-column prop="deptName" label="单位" show-overflow-tooltip></el-table-column>
				<el-table-column prop="idno" label="身份证" width="150"></el-table-column>
				<el-table-column prop="validDate" label="有效期" width="160"></el-table-column>
			</el-table>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="doSelectDrivers">确认选择</el-button>
				<el-button @click="visible.selectEmp = false">取 消</el-button>
			</span>
		</el-dialog>

		<takeImage ref="takeImage" @toOk="saveImage" :autoCropWidth="400" :autoCropHeight="300"></takeImage>
	</div>
</template>

<script>
	import takeImage from '../usercontrol/TakeImage.vue'
	export default {
		name: 'vehrehandle',
		data() {
			return {
				data: {
					depts: [],
					filterstr: '',
					filterselempstr: '',
					total: 500,
					size: 10,
					page: 1,
					rows: [],
					filterDeptStr: '',
					curDeptId: '0',
					containSubEmployee: true,
					curVehId: 0,
					selectEmployees: [],
					selectEmpSelections: [],
					info: {
						id: 0,
						code: '',
						licensePlate: '',
						driName: '',
						driCode: '',
						idno: '',
						deptId: 0,
						oldDept: '',
						deptName: '',
						realDeptName: '',
						doorPost: '',
						carType: 0,
						dri: '',
						cardNo: '',
						isNormal: true,
						drivers: [],
						oldDrivers: [],
						hasVeh: false,
						diffDept: false,
						clearDrivers: false
					},
					handle: {
						step: 0,
						img: '',
						power: [],
						passType: [],
						cardTxtFocusStatus: false,
						canCheckData1: false
					},
					image: {
						img: '',
						//0 - 拍照，   1 - 本地，   2 - 脸谱
						imgType: 0
					},
					authorizeGroups: [{
							id: '18',
							name: '1#岗',
							checked: false
						},
						{
							id: '19',
							name: '2#岗',
							checked: false
						},
						{
							id: '20',
							name: '6#岗',
							checked: false
						},
						{
							id: '44',
							name: '7#岗',
							checked: false
						}
					]
				},
				visible: {
					loading: false,
					handle: false,
					selectEmp: false
				},
				power: {
					pageId: 24,
					search: false,
					handle: false,
					remove: false
				}
			}
		},
		methods: {
			readFromIdCardReader() {
				let ths = this;
				ths.dev.gethsidcardreader(ths, 'data.filterselempstr', 'visible.loading', v => {
					ths.search(true);
				});
			},
			search(change) {
				let ths = this;
				ths.loading = false;
				ths.$refs.table.setCurrentRow(false);
				ths.data.curVehId = 0;
				if (change) {
					ths.data.page = 1;
				}
				window.ax.get('api/rehandle/vehicle/list?id=' + ths.data.curDeptId + '&pagesize=' + ths.data.size +
					'&currentpage=' + ths.data.page + '&sign=' + window.$gloable.userinfo.sign + '&filterStr=' + ths
					.data.filterstr + '&idstr=' + (ths.data.containSubEmployee ? '1' : '0')).then(rsp => {
					let data = rsp.data;
					if (data.code == 1) {
						data = data.data;
						let len = data.datas.length;
						let total = data.totalRecord;
						ths.data.rows = data.datas;
						ths.data.total = total;
						if (len == 0 && total > 0) {
							ths.data.page = Math.ceil(total / ths.data.size);
							ths.search();
						}
					} else {
						ths.$message.error(data.message);
					}
					ths.visible.loading = false;
				}).catch(err => {
					ths.$message.error('执行脚本出错，请联系管理员');
					ths.visible.loading = false;
				});
			},
			tableCurrentChange(row) {
				this.data.curVehId = row.id;
			},
			handleSizeChange(size) {
				this.data.size = size;
				this.data.page = 1;
				this.search();
			},
			handleCurrentPageChange(current) {
				this.data.page = current;
				this.search();
			},
			changeContainSubEmployee() {
				this.search(true);
			},
			filterDept() {
				this.data.filterDeptStr = this.data.filterDeptStr.toLowerCase();
				this.$refs.depts.filter(this.data.filterDeptStr);
			},
			handleDeptNodeClick(data, node, target) {
				let ths = this;
				if (ths.data.curDeptId != data.id) {
					ths.data.curDeptId = data.id;
					ths.data.filterstr = '';
					ths.search(true);
				}
			},
			handleTreeFilter(value, data, node) {
				if (!value) {
					return true;
				} else {
					return data.label && data.label.toLowerCase().indexOf(value) != -1;
				}
			},
			toHandle() {
				let ths = this;
				if (ths.data.curVehId > 0) {
					ths.visible.loading = true;
					ths.data.handle.canCheckData1 = true;
					window.ax.get('api/rehandle/vehicle/info?id=' + ths.data.curVehId + '&sign=' + window.$gloable
						.userinfo.sign).then(rsp => {
						let data = rsp.data;
						if (data.code == 1) {
							let inf = data.data;
							ths.data.info.code = inf.code;
							ths.data.info.licensePlate = inf.licensePlate;
							ths.data.info.deptId = inf.deptId;
							ths.data.info.oldDept = inf.oldDept;
							ths.data.info.realDeptName = inf.realDeptName;
							ths.data.info.doorPost = inf.doorPost;
							ths.data.info.oldDrivers = inf.oldDrivers;
							ths.data.info.hasVeh = inf.hasVeh;
							ths.data.info.diffDept = inf.diffDept;
							ths.data.info.isNormal = true;
							ths.data.info.drivers = [];
							let powers = inf.doorPost.split(',');
							if (powers[0] == '') {
								powers = []
							}
							ths.data.handle.power = powers;
							ths.data.handle.step = 0;
							ths.data.info.clearDrivers = true;
							if (data.hasVeh) {
								if (data.diffDept) {
									ths.data.info.clearDrivers = true;
									ths.data.handle.canCheckData1 = false;
								}
							}
							ths.visible.handle = true;
						} else {
							ths.$message.error(data.message);
						}
						ths.visible.loading = false;
					}).catch(err => {
						ths.$message.error('执行脚本出错，请联系管理员');
						ths.visible.loading = false;
					});
				} else {
					ths.$message.warning('请选择待办车辆');
				}
			},
			finishCheckData() {
				let ths = this;
				ths.visible.loading = true;
				let opt = {
					Sign: window.$gloable.userinfo.sign,
					ApplyId: ths.data.curVehId,
					LicensePlate: ths.data.info.licensePlate,
					Image: ths.data.image.img
				};
				window.ax.post('api/rehandle/vehicle/saveimage', opt).then(rsp => {
					let data = rsp.data;
					if (data.code == 1) {
						ths.data.handle.step = 1;
						if (ths.data.info.clearDrivers) {
							ths.data.info.drivers = [];
						} else {
							ths.data.info.drivers = ths.data.info.oldDrivers;
						}
					} else {
						ths.$message.error(data.message);
					}
					ths.visible.loading = false;
				}).catch(err => {
					console.log(err);
					ths.$message.error('执行脚本出错，请联系管理员');
					ths.visible.loading = false;
				});
			},
			backToCheckData() {
				this.data.handle.step = 0;
			},
			finishDrivers() {
				this.data.handle.step = 2;
			},
			backToDrivers() {
				this.data.handle.step = 1;
			},
			saveData() {
				let ths = this;
				ths.visible.loading = true;
				let opt = {
					Sign: window.$gloable.userinfo.sign,
					ApplyId: ths.data.curVehId,
					LicensePlate: ths.data.info.licensePlate,
					Drivers: [],
					Power: ths.data.handle.power,
					IsNormal: ths.data.info.isNormal,
					ClearDriver: ths.data.info.clearDrivers
				};
				for (let i = 0; i < ths.data.info.drivers.length; i++) {
					opt.Drivers.push(ths.data.info.drivers[i].id);
				}
				window.ax.post('api/rehandle/vehicle/save', opt).then(rsp => {
					let data = rsp.data;
					if (data.code == 1) {
						ths.search();
						ths.data.handle.step = 4;
					} else {
						ths.$message.error(data.message);
					}
					ths.visible.loading = false;
				}).catch(err => {
					console.log(err);
					ths.$message.error('执行脚本出错，请联系管理员');
					ths.visible.loading = false;
				});
			},
			doCloseHandle() {
				this.visible.handle = false;
				this.search(true);
			},
			blobToBase64(blob) {
				return new Promise((resolve, reject) => {
					const reader = new FileReader();
					reader.onload = e => {
						resolve(e.target.result);
					};
					reader.onerror = () => {
						reject(new Error('文件流异常'));
					}
					reader.readAsDataURL(blob);
				});
			},
			loadLocationImage() {
				this.$refs.takeImage.init();
			},
			saveImage(img, type) {
				let ths = this;
				if (type == 'camera') {
					ths.data.image.imgType = 0;
				} else if (type == 'location') {
					ths.data.image.imgType = 1;
				}
				ths.blobToBase64(img).then(r => {
					ths.data.image.img = r;
					ths.data.image.imgType = 2;
				});
			},
			toCropper() {
				let ths = this;
				this.$refs.takeImage.init();
				this.$refs.takeImage.setCurrentImage(ths.data.image.img);
			},
			toSelectDrivers() {
				let ths = this;
				ths.visible.selectEmp = true;
			},
			doSelectDrivers() {
				let ths = this;
				for (let e of ths.data.selectEmpSelections) {
					let exists = true;
					for (let s of ths.data.info.drivers) {
						if (s.id == e.id) {
							exists = false;
							break;
						}
					}
					if (exists) {
						ths.data.info.drivers.push(e);
					}
				}
				ths.data.filterselempstr = '';
				ths.data.selectEmployees.splice(0, ths.data.selectEmployees.length);
				ths.data.selectEmpSelections.splice(0, ths.data.selectEmpSelections.length);
				ths.visible.selectEmp = false;
			},
			doRemoveDriver(idx) {
				this.data.info.drivers.splice(idx, 1);
			},
			selectEmpHandleSelectionChange(selections) {
				this.data.selectEmpSelections = selections;
			},
			selectEmpHandleCellClick(row, column, cell, event) {
				if (column.property != 'opt') {
					this.$refs.selectEmps.toggleRowSelection(row, this.data.selectEmpSelections.indexOf(row) == -1);
				}
			},
			searchSelectEmpoyee() {
				let ths = this;
				ths.visible.loading = true;
				window.ax.get('api/personnal/employee/list?sign=' + window.$gloable.userinfo.sign +
					'&filterStr=' + ths.data.filterselempstr).then(rsp => {
					let data = rsp.data;
					if (data.code == 1) {
						ths.data.selectEmployees = data.data;
					} else {
						ths.$message.error(data.message);
					}
					ths.visible.loading = false;
				}).catch(err => {
					ths.$message.error('执行脚本出错，请联系管理员');
					ths.visible.loading = false;
				});
			},
			removeApply() {
				let ths = this;
				let opt = {Sign:window.$gloable.userinfo.sign,id:ths.data.curVehId};
				ths.visible.loading = true;
				window.ax.post('api/rehandle/vehicle/removeapply', opt).then(rsp => {
					let data = rsp.data;
					if (data.code == 1) {
						ths.search();
						ths.$message.success(data.message);
					} else {
						ths.$message.error(data.message);
					}
					ths.visible.loading = false;
				}).catch(err => {
					console.log(err);
					ths.visible.loading = false;
				});
			}
		},
		created() {
			this.baseJS.initPower(this.power);
			this.api.loadDepartmentTree(this, 'data.depts', 'visible.loading');
			this.search(true);
		},
		mounted() {},
		components: {
			takeImage
		}
	}
</script>

<style>
	.red>>>input {
		color: red;
	}

	.ml10 {
		margin-left: 10px;
	}

	.handle-input {
		width: 200px;
		display: inline-block;
	}

	.handle-box {
		margin-bottom: 20px;
	}

	.left {
		float: left;
		margin-left: 10;
	}

	.right {
		float: right;
		margin-right: 10;
	}

	.handle-select {
		width: 120px;
	}

	.table {
		width: 100%;
		font-size: 14px;
	}

	.el-tree-node__content {
		height: 36px !important;
	}

	.dialog-footer {
		height: 30px;
	}
</style>
